import { FontSizeTheme } from '@kite-js/theme-types';

const sizes: FontSizeTheme = {
    XXXXL: '56px',
    XXXL: '40px',
    XXL: '24px',
    XL: '20px',
    L: '16px',
    M: '14px',
    S: '12px',
    XS: '10px',
};

export default sizes;
